import { mapGetters } from "vuex"
import Pusher from 'pusher-js'

// const soundNewOrder = new Audio(require("../assets/sounds/online_order_notificaiton.wav"));

export default {
  data: () => ({
    pusher: null,
    cdPusher: null,
    userHasInteracted: false,
  }),
  computed: {
    ...mapGetters({
        baseUrl: "config/baseUrl",
        store: "config/store",
        terminal: "config/terminal"
    }),
  },
  created() {
    // Add event listeners to track user interaction
    window.addEventListener('click', this.userInteraction);
    window.addEventListener('keydown', this.userInteraction);
  },
  beforeDestroy() {
    // Clean up event listeners when component is destroyed
    window.removeEventListener('click', this.userInteraction);
    window.removeEventListener('keydown', this.userInteraction);

    if (this.cdPusher) {
      this.cdPusher.disconnect()
      this.cdPusher = null
    }
  },
  methods: {
    userInteraction() {
      this.userHasInteracted = true;
    },
    // Single entry point for (re)establishing the Pusher connection. Safe to
    // call repeatedly — it only tears down and re-subscribes when the
    // connection isn't actually in a healthy 'connected' state, so callers
    // (visibility change, online/offline, mount) don't need to worry about
    // duplicating subscriptions.
    ensureSubscribed() {
      if (!navigator.onLine || !this.baseUrl) {
        return;
      }

      const isHealthy = this.pusher && this.pusher.connection &&
        (this.pusher.connection.state === 'connected' || this.pusher.connection.state === 'connecting');

      if (isHealthy) {
        return;
      }

      this.teardownPusher();
      this.subscribe();
    },
    teardownPusher() {
      if (this.pusher) {
        this.pusher.disconnect();
        this.pusher = null;
      }
      if (this.cdPusher) {
        this.cdPusher.disconnect();
        this.cdPusher = null;
      }
    },
    subscribe() {
        let clientName = this.baseUrl.split("//")[1].split(".")[0].replace(":", "_");
        const domainNameFromStorage = localStorage.getItem('domainName')
        if (domainNameFromStorage) {
          clientName = domainNameFromStorage
        }

        let storeId;
        if (this.store && this.store.id) {
          storeId = this.store.id;
        } else {
          storeId = "demo";
        }
        let subscribeChannel = `${clientName}_${storeId}_channel`;
        this.pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, { cluster: process.env.VUE_APP_PUSHER_CLUSTER, debug: true, });
        let channel = this.pusher.subscribe(subscribeChannel);

        // pusher-js retries internally, but on some networks/devices it can get
        // stuck (e.g. after a long sleep). Watch the connection state so a
        // stalled connection gets an explicit nudge instead of silently
        // never recovering.
        this.pusher.connection.bind('unavailable', () => {
          setTimeout(() => this.ensureSubscribed(), 3000);
        });
        this.pusher.connection.bind('failed', () => {
          setTimeout(() => this.ensureSubscribed(), 3000);
        });

        // Subscribe to POS specific channel for CD communication
        // IMPORTANT: CD->POS messages are published via a different Pusher app/cluster (us2)
        // so we use a dedicated Pusher client here.
        const terminalIdFromStorage = localStorage.getItem('terminalId')
        const terminalId = (this.terminal && this.terminal.id) ? this.terminal.id : terminalIdFromStorage

        if (terminalId) {
          const posChannelName = `${clientName}_${terminalId}_pos`;

          this.cdPusher = new Pusher(process.env.VUE_APP_PUSHER_CD_KEY, { cluster: process.env.VUE_APP_PUSHER_CD_CLUSTER, debug: true })
          const posChannel = this.cdPusher.subscribe(posChannelName);

          posChannel.bind('pos-update', (data) => {
            this.$root.$emit('cd-pos-update', data);
          });
        }

        // const ordersNotification = this.terminal.db_settings.find((item) => item.name === "orders_notification")
        // && this.terminal.db_settings.find((item) => item.name === "orders_notification")["value"] === "true";

        channel.bind("orders-event", (data) => {
          const realtime = this.$store.state.realtime;
          const isRealtimeActive = !!(realtime && realtime.isConnected && !realtime.isDisabled);

          // When Ably is active, rely entirely on it for table restrictions and order updates
          // Ably will handle order:update events which automatically update table restrictions
          // Pusher is only used for notifications (sound, UI notifications)
          if (!isRealtimeActive) {
            // Only fetch via HTTP when Ably is NOT active (fallback mode)
            if (this.$route.name === "Tables") {
              this.$store.dispatch("orders/fetchOpenOrders");
              // this.$store.dispatch("orders/fetchUpdatedTableOrders", data.instance_id);
              // this.$store.dispatch("config/fetchSections");
              // this.$store.dispatch("config/fetchTables");
            }
          }

          // Handle notifications for fetchPendingOrder (new online orders)
          if(data.call && data.call === "fetchPendingOrder") {
            // Add UI notification (sound is handled by notifications module)
            this.$store.dispatch("notifications/addNotification", {
              title: "New Order Received",
              message: "A new online order #" + data.instance_id + " has been received. Click to view.",
              data: data
            });

            // Online orders arrive via Pusher (not Ably), so auto-fire the
            // incoming order to the kitchen when `autosend_kitchen_online` is on.
            // Delay slightly so the backend has finished persisting the order.
            setTimeout(() => {
              this.$store.dispatch("orders/autoSendOnlineKitchenById", data.instance_id);
            }, 5000);

            // When Ably is active, rely on it for order updates and table restrictions
            // Ably will receive order:update events from backend and update tables automatically
            // Only fetch via HTTP if Ably is not active (fallback)
            if (!isRealtimeActive) {
              // Fetch orders after a delay to ensure backend has processed the order
              setTimeout(() => {
                // Fetch online orders for the notification list
                this.$store.dispatch("orders/fetchOnlineOrders");

                // Fetch open orders to update table restrictions (fallback when Ably inactive)
                this.$store.dispatch("orders/fetchOpenOrders");

                // Fetch updated table orders for any status changes
                if (data.instance_id) {
                  // this.$store.dispatch("orders/fetchUpdatedTableOrders", data.instance_id);
                }

                // Update tables and sections
                if (this.$route.name === "Tables") {
                  // this.$store.dispatch("config/fetchSections");
                  // this.$store.dispatch("config/fetchTables");
                }
              }, 5000);
            }
            // When Ably is active, no HTTP calls needed - Ably handles everything

            // Still show modal if not on specific pages and orders notification is enabled
            // if(ordersNotification && this.$route.name !== "OnlineOrder" && this.$route.name !== 'Pin' && this.$route.name !== 'Auth') {
            //   this.$bvModal.show("new-order-received")
            // } else {
            //   this.$bvModal.hide("new-order-received")
            // }
          }
          // Handle KitchenHub order relay events. The backend receiver does the
          // minimum possible (verify + resolve brand) and hands off here — the
          // frontend fetches the order, builds it locally, and pushes it through
          // the same Ably broadcast + order-queue sync pipeline every other
          // order type uses (see orders/receiveKitchenHubOrder).
          if (data.call && data.call === "fetchPendingKitchenHubOrder") {
            this.$store.dispatch("orders/receiveKitchenHubOrder", {
              kitchenhub_order_id: data.kitchenhub_order_id,
              brand_id: data.brand_id
            });
          }

          // Notify any open view (e.g. Online Orders) so it can refresh
          // immediately instead of waiting for its polling interval.
          this.$root.$emit('orders-event', data);
          this.$forceUpdate();
        });
        channel.bind("new-version", () => {
          // Add notification for new version
          this.$store.dispatch("notifications/addNotification", {
            title: "New Version Available",
            message: "A new version of the application is available. Click to update.",
            data: {}
          });

          // Still show modal
          this.$bvModal.show('sw-update-modal')
        });
        channel.bind("curbsideorder-pickup-event", (data) => {
          // Add notification for curbside pickup (sound is handled by notifications module)
          this.$store.dispatch("notifications/addNotification", {
            title: "Curbside Pickup",
            message: `Customer is outside for Order #${data.order_id}. Click to view details.`,
            data: data
          });

          // // Still show modal and set order data
          // this.$store.dispatch("order/setCurbsidePickupOrder", data)
          // this.$bvModal.show('curbside-pickup')
        });
      }

  },

}
